





















































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import { ProductsApi } from '../../../api';
import { Organisation } from '@/models/organisation';
import addOrg from '@/components/add business objects/addOrg.vue';
import addOrgAdmin from '@/components/add business objects/addOrgAdmin.vue';
import addBilling from '@/components/add business objects/addBilling.vue';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		addOrg,
		addOrgAdmin,
		addBilling,
		secondaryNav,
		vSelect,
		Toast,
	},
})
export default class OrganisationAdd extends Vue {
	public existingOrg = false;
	public existingUser = false;
	public existingSite = false;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;
	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;
	public site: any = {
		id: undefined,
		orgId: undefined,
		name: '',
		address: { fullAdr: '', region: '', location: '' },
	};
	public org: Organisation = {
		id: '',
		name: '',
		tradingName: '',
		adminId: '',
		orgType: this.$route.params.orgType,
		admin: { id: '', name: '', phone: '', email: '' },
		sites: [],
		address: { fullAdr: '', region: '', location: '' },
		subscription: {
			id: '',
			paymentMethod: '',
			accountApproved: '',
			directDebitDate: '',
			accountName: '',
			accountNumber: '',
			paymentMethodActive: false,
		},
		activeSiteId: '',
		farmSourceRegion: '',
	};

	public product = {};

	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public stepValidate(name: string) {
		return () => {
			const form = this.$v[name];
			form.$touch();
			return !form.$invalid;
		};
	}
}
